module.exports = __webpack_public_path__ + "static/media/hashtag-nft-11.b9bfcd7b.jpg";